export default "__VITE_ASSET__ef7d218c__"